import { createContext } from 'react';
import api from '../../../api/api'
import { PLAN_CONFIG } from '../config';

const PlanContext = createContext({})
export const PlanProvider = ({ children }) => {
    const getPlanProductionReasons = async (setData) => {

        let _params = '';

        const res = await api.get(PLAN_CONFIG.requests.getPlanChangeReasons.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getPlanProductionList = async (documentNo, setData) => {

        let _params = '';

        if (documentNo) {
            _params = '?documentNo=' + documentNo;
        }


        const res = await api.get(PLAN_CONFIG.requests.getPlanProduction.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }


    const planProductionAdd = async (body, mode, setData) => {


        if (mode === 'edit') {
            const DocNo = encodeURIComponent(body?.DocumentNo)
            const url = PLAN_CONFIG.requests.getPlanProduction.url + `/${DocNo}`;
            const res = await api.put(url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        } else {

            const res = await api.post(PLAN_CONFIG.requests.getPlanProduction.url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        }

    }


    const getPlanProductioDetail = async (DocumentNo, version, setData) => {
        let _params = '';
        if (version) {
            _params = '?version=' + version;
        }
        const _DocumentNo = encodeURIComponent(DocumentNo);
        const url = PLAN_CONFIG.requests.getPlanProduction.url + `/${_DocumentNo}`;
        const res = await api.get(url + _params );
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getPlanSaleList = async (documentNo, setData) => {

        let _params = '';

        if (documentNo) {
            _params = '?documentNo=' + documentNo;
        }


        const res = await api.get(PLAN_CONFIG.requests.getPlanSale.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }


    const planSaleAdd = async (body, mode, setData) => {

        if (mode === 'edit') {
            const url = PLAN_CONFIG.requests.getPlanSale.url + `/${body?.DocumentNo}`;
            const res = await api.put(url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        } else {
            const res = await api.post(PLAN_CONFIG.requests.getPlanSale.url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        }
    }


    const getPlanSaleDetail = async (DocumentNo, setData) => {
        const _DocumentNo = encodeURIComponent(DocumentNo);
        const url = PLAN_CONFIG.requests.getPlanSale.url + `/${_DocumentNo}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }



    const getDistributionList = async (documentNo, setData) => {

        let _params = '';

        if (documentNo) {
            _params = '?documentNo=' + documentNo;
        }
        const res = await api.get(PLAN_CONFIG.requests.getPlanDistribution.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }


    const planDistributionAdd = async (body, mode, setData) => {

        if (mode === 'edit') {
            const url = PLAN_CONFIG.requests.getPlanDistribution.url + `/${body?.DocumentNo}`;
            const res = await api.put(url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        } else {

            const res = await api.post(PLAN_CONFIG.requests.getPlanDistribution.url, body)
            const data = res.data
            if (data.status === true) {
                setData(data.result)
            }
        }
    }


    const getPlanDistributionDetail = async (DocumentNo, setData) => {
        const _DocumentNo = encodeURIComponent(DocumentNo);
        const url = PLAN_CONFIG.requests.getPlanDistribution.url + `/${_DocumentNo}`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }


    const getPlanDelivery = async (date, setData) => {

        let _params = ''

        if (date) {
            _params = '?date=' + date
        }


        const res = await api.get(PLAN_CONFIG.requests.getPlanDelivery.url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }



    }
    const planDeliveryAdd = async (body, setData) => {
        const res = await api.post(PLAN_CONFIG.requests.getPlanDelivery.url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }


    const getCampaignList = async (setData) => {
        const res = await api.get(PLAN_CONFIG.requests.getPlanCampaigns.url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const getDeliveryDoc = async (setData) => {


        const res = await api.get(PLAN_CONFIG.requests.getPlanDelvieryDoc.url)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }


    // async GetCampaignInfo(body: any, mode: string) {

    //     let res: ResponseAPI;

    //     if (mode === 'edit') {
    //         const url = PLAN_CONFIG.requests.getPlanCampaigns.url + `/${body?.DocumentNo}`;
    //         res = await this.http.put<ResponseAPI>(url, body).toPromise();
    //     } else {

    //         res = await this.http.post<ResponseAPI>(PLAN_CONFIG.requests.getPlanCampaigns.url, body).toPromise();

    //     }
    //     return res;
    // }


    const GetCampaignInfo = async (reserveNo, BranchNo, setData) => {
        let _params = ''

        if (BranchNo) {
            _params = '?branchNo=' + BranchNo
        }
        const _DocumentNo = encodeURIComponent(reserveNo);
        const url = PLAN_CONFIG.requests.getPlanCampaigns.url + `/${_DocumentNo}`;
        const res = await api.get(url + _params)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

    const planCampaignAdd = async (body, reserveNo, setData) => {
        const _DocumentNo = encodeURIComponent(reserveNo);
        const url = PLAN_CONFIG.requests.getPlanCampaigns.url + `/${_DocumentNo}`;

        const res = await api.post(url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }





    const contextData = {
        getPlanSaleDetail: getPlanSaleDetail,
        getPlanDistributionDetail: getPlanDistributionDetail,
        getPlanDelivery: getPlanDelivery,
        GetCampaignInfo: GetCampaignInfo,
        getPlanProductioDetail: getPlanProductioDetail,
        getPlanProductionReasons: getPlanProductionReasons,
    }
    return (
        <PlanContext.Provider value={contextData}>
            {children}
        </PlanContext.Provider>
    )
}

export default PlanContext
